import Upload from './Upload';
import Dragger from './Dragger';
Upload.Dragger = Dragger;
export default Upload;
//# sourceMappingURL=index.js.map



//////////////////
// WEBPACK FOOTER
// ../~/_antd@3.23.4@antd/es/upload/index.js
// module id = 864
// module chunks = 0